/**
 * TinyMCE-facing placeholder helpers.
 *
 * The scanning half of this module — `extractPlaceholderVarNames`, `getInvalidPlaceholders`,
 * `hasInvalidPlaceholders`, `nodesContainSignatureVariable` — moved to
 * `@signalist/shared-types` with the campaign rulebook (PREC-4153), because the API validates
 * campaign content too and must read the same tokens. What is left here is about the editor:
 * how an invalid pill is painted, and whether a pill matches the suggestion list the editor
 * happens to be showing.
 */

/**
 * CSS style for invalid placeholders (red styling).
 * Add this to `content_style` in TinyMCE editor config.
 */
export const invalidPlaceholderStyle = `
	span[data-placeholder][data-invalid="true"] {
		background: #fef2f2;
		border: 1px solid #fca5a5;
		border-radius: 999px;
		padding: 2px 6px;
		font-size: 0.9em;
		color: #dc2626;
		font-weight: 500;
		white-space: nowrap;
		cursor: help;
	}
`;

/**
 * Checks if a placeholder variable name is valid against the processed suggestions list.
 */
export const isValidPlaceholder = (
	varName: string,
	processedSuggestions: { text: string; value: string }[]
): boolean => {
	return processedSuggestions.some((s) => s.value === varName);
};
